import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { api } from '../api/http.js';
import { setPlantTimezone } from '../composables/useElapsed.js';

/* Настройки предприятия. Читаются один раз при входе: название компании
   в шапке, целевые KPI на дашбордах, правила учёта на операторском экране. */
export const useSettingsStore = defineStore('settings', () => {
  const values = ref({});
  const items = ref([]);
  const loading = ref(false);
  let inflight = null;

  async function load(force = false) {
    if (!force && Object.keys(values.value).length) return values.value;
    if (inflight) return inflight;
    loading.value = true;
    inflight = api.get('/settings')
      .then((d) => {
        values.value = d.values || {};
        items.value = d.items || [];
        /* Пояс раздаём форматтерам сразу: иначе экраны печатали бы время
           по поясу планшета, а шапка и сервер — по поясу цеха */
        setPlantTimezone(values.value['company.timezone']);
        return values.value;
      })
      .catch(() => values.value)
      .finally(() => { loading.value = false; inflight = null; });
    return inflight;
  }

  async function save(patch) {
    const r = await api.patch('/settings', { values: patch });
    values.value = r.values || values.value;
    setPlantTimezone(values.value['company.timezone']);
    return r;
  }

  const get = (key, fallback = null) => (values.value[key] ?? fallback);

  // Название предприятия показывается рядом с логотипом: система одна, заказчики разные
  const companyName = computed(() => get('company.name', ''));
  const timezone = computed(() => get('company.timezone', ''));

  const targets = computed(() => ({
    oee: get('kpi.oeeTarget', null),
    plan: get('kpi.planTarget', null),
    scrap: get('kpi.scrapLimit', null),
  }));

  return { values, items, loading, load, save, get, companyName, timezone, targets };
});
